module.exports = __webpack_public_path__ + "img/page16_logo.70a2e11f.png";